var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{staticClass:"ir-module-block",attrs:{"loading":_setup.quarterly_performance.loading,"empty":_setup.isEmpty}},[_c(_setup.CFinancialCard,{attrs:{"quarterInfo":_setup.pageData,"inOverview":""}},[_c('div',{staticClass:"quarter-perf-title"},[_vm._v(_vm._s(_setup.getPerfTitle))])]),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }